import axios from "axios";
import { FORGOT_PASSWORD_API, LOGIN_API, LOGOUT_API, RESET_PASSWORD_API, CUSTOMER_INFO_API, UPDATE_CREDIT_CARD } from "../../global/ApiUrl";

export const loginAPI = async (payload) => {

  try {
    const response = await axios.post(LOGIN_API, payload);
    return response;

  } catch (error) {
    console.log("loginAPI catch block", error);
    return { success: false, error };
  }
};

export const logoutAPI = async () => {

  try {
    const response = await axios.post(LOGOUT_API);
    return response;

  } catch (error) {
    console.log("logoutAPI catch block", error);
    return { success: false, error };
  }
};


export const customerInfoAPI = async () => {

  try {
    const response = await axios.post(CUSTOMER_INFO_API);
    return response;

  } catch (error) {
    console.log("customerInfoAPI catch block", error);
    return { success: false, error };
  }
}

export const forgotPasswordAPI = async (payload) => {

  try {
    const response = await axios.post(FORGOT_PASSWORD_API, payload);
    return response;

  } catch (errors) {
    console.log("forgotPasswordAPI catch block", errors);
    return { success: false, errors };
  }
};

export const resetPasswordAPI = async (token, payload) => {

  try {
    const response = await axios.post(RESET_PASSWORD_API, payload, { params: { token } });

    return response;
  } catch (errors) {
    console.log("resetPasswordAPI catch block", errors);
    return { success: false, errors };
  }
};


export const updateCreditCardAPI = async (payload) => {

  try {
    const response = await axios.post(UPDATE_CREDIT_CARD, payload);
    return response;

  } catch (error) {
    console.log("updateCreditCardAP catch block", error);
    return { success: false, error };
  }
}